export const scoreBrackets = {
  'great': 90,
  'good': 80,
  'ok': 70,
  'poor': 60
};

export const scoreBracket = (score) => {
  return Object.keys(scoreBrackets).find(bracket => score >= scoreBrackets[bracket]) || 'poor';
};



// WEBPACK FOOTER //
// ./src/utils/score_meta.js